import { useState, useCallback, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Tab, Tabs, TabList, TabPanel } from '@gusto/workbench';
import { getAnswersFromStorage } from 'packages/signup/helpers/storageHelpers';
import { SurveyQuestionsKeys } from 'packages/signup/components/SurveyQuestions';
import { WhatToUseValues } from 'packages/signup/components/SurveyQuestions/WhatToUse';
import LoadingSkeleton from './skeleton';

const pageNames = {
  payroll: 'Payroll',
  time: 'Time + attendance',
  hiring: 'Hiring + onboarding',
  benefits: 'Employee benefits',
  talent: 'Talent management',
  reporting: 'Insights + reporting',
  explore: '',
};

export default function ExploreWithTabs() {
  const [pages, setPages] = useState([]);
  const [value, setValue] = useState(pages ? pages[0] : '');
  const onClick = useCallback((e: any) => setValue(e?.target?.value), []);

  useEffect(() => {
    const surveyAnswers = getAnswersFromStorage(SurveyQuestionsKeys.WHAT_TO_USE);
    setPages(isEmpty(surveyAnswers) ? Object.values(WhatToUseValues) : surveyAnswers);
  }, []);

  return (
    <div className="how-it-works-wrapper">
      <div className="container padding-none">
        <Tabs value={value}>
          <TabList className="custom-ul" aria-label="Explore Gusto Payroll and HR features">
            {pages?.map((page: string) => (
              <Tab
                key={page}
                value={page}
                id={`how-it-works-tab-${page}`}
                onClick={e => {
                  GustoAnalytics.trackDomEvent(e);
                  onClick(e);
                }}
              >
                {pageNames[page as keyof typeof pageNames]}
              </Tab>
            ))}
          </TabList>
          {pages?.map((page: any, index: any) => {
            return (
              <TabPanel id={`tab-panel-${index}`} key={`tab-panel-${page}`}>
                <LoadingSkeleton />
              </TabPanel>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
}
